// frontend/src/pages/teacher/CourseListPage.js (نسخه اصلاح شده)

import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, getAuthHeaders } from '../../modules/api';
// ✅ ایمپورت FaUsers برای دکمه گروه‌ها
import { FaBookOpen, FaUserGraduate, FaTasks, FaPlus, FaSearch, FaSpinner, FaPen, FaTrash, FaUsers } from 'react-icons/fa'; 
import '../../assets/styles/global.css';
import CreateCourseModal from './CreateCourseModal'; 

const CourseListPage = () => {
    const navigate = useNavigate();
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    // (تابع fetchCourses بدون تغییر)
    const fetchCourses = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(`${API_BASE_URL}/core/teacher/courses/`, getAuthHeaders());
            setCourses(response.data);
        } catch (err) {
            console.error("Error fetching courses:", err);
            setError("خطا در بارگذاری دوره‌ها. لطفا اتصال خود را بررسی کنید.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCourses();
    }, []);

    // (تابع handleDeleteCourse بدون تغییر)
    const handleDeleteCourse = async (courseId, courseTitle) => {
        if (!window.confirm(`آیا مطمئن هستید که می‌خواهید دوره "${courseTitle}" را حذف کنید؟`)) {
            return;
        }
        try {
            await axios.delete(`${API_BASE_URL}/core/teacher/courses/${courseId}/`, getAuthHeaders());
            alert(`دوره "${courseTitle}" با موفقیت حذف شد.`);
            fetchCourses(); 
        } catch (err) {
            console.error("Error deleting course:", err);
            alert(err.response?.data?.detail || "خطا در حذف دوره.");
        }
    };

    const handleCourseCreated = () => {
        fetchCourses();
    };

    // (تابع filteredCourses بدون تغییر)
    const filteredCourses = courses.filter(course =>
        course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (course.grade && course.grade.name && course.grade.name.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const renderTableBody = () => {
        if (loading) {
            return (
                <tr>
                    <td colSpan="5" className="text-center">
                        <FaSpinner className="spinner" style={{ fontSize: '2rem', margin: '20px' }} />
                        <p>در حال بارگذاری لیست دوره‌ها...</p>
                    </td>
                </tr>
            );
        }
        if (error) {
            return <tr><td colSpan="5" className="alert alert-danger text-center">{error}</td></tr>;
        }
        if (filteredCourses.length === 0) {
            return <tr><td colSpan="5" className="text-center">شما هیچ دوره‌ای برای تدریس ندارید.</td></tr>;
        }

        return filteredCourses.map(course => (
            <tr key={course.id}>
                <td>
                    <div className="user-cell">
                        <FaBookOpen style={{ color: '#007bff' }} />
                        <Link 
                            to={`/teacher/courses/${course.id}/lessons`}
                            style={{color: 'var(--text-light)', fontWeight: 'bold'}}
                            title="مشاهده دروس و تالارهای گفتگو"
                        ></Link>
                        <span>{course.title}</span>
                    </div>
                </td>
                <td>{course.grade?.name || '—'}</td> 
                {/* TODO: این ستون‌ها بعداً با داده واقعی پر می‌شوند */}
                <td>(؟) دانش‌آموز</td> 
                <td>(؟) تکلیف</td>
                <td>
                    <div className="action-buttons">
                        
                        {/* ✅✅✅ دکمه جدید مدیریت گروه‌ها ✅✅✅ */}
                        <button 
                            className="action-btn" 
                            style={{backgroundColor: '#17a2b8'}} // رنگ فیروزه‌ای (info)
                            title="مدیریت گروه‌ها"
                            onClick={() => navigate(`/teacher/courses/${course.id}/groups`)}
                        >
                            <FaUsers />
                        </button>

                        <button 
                            className="action-btn btn-view" 
                            title="مشاهده دانش‌آموزان"
                            onClick={() => navigate(`/teacher/students?course=${course.id}`)}
                        >
                            <FaUserGraduate />
                        </button>
                        <button 
                            className="action-btn btn-edit" 
                            title="مدیریت تکالیف"
                            onClick={() => navigate(`/teacher/assignments?course=${course.id}`)}
                        >
                            <FaTasks />
                        </button>
                        <button 
                            className="action-btn btn-edit" 
                            title="ویرایش دوره" 
                            onClick={() => navigate(`/teacher/courses/${course.id}`)}
                        >
                            <FaPen /> 
                        </button>
                        <button 
                            className="action-btn btn-delete" 
                            title="حذف دوره" 
                            onClick={() => handleDeleteCourse(course.id, course.title)} 
                        >
                            <FaTrash />
                        </button>
                    </div>
                </td>
            </tr>
        ));
    };

    return (
        <>
            {/* ... (بخش Modal بدون تغییر) ... */}
            <CreateCourseModal 
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onCourseCreated={handleCourseCreated}
            />

            <div className="page-container" style={{maxWidth: '1200px'}}>
                {/* ... (بخش Header و Table Toolbar بدون تغییر) ... */}
                <div className="page-header">
                    <div>
                        <h1>مدیریت دوره‌ها</h1>
                        <p>لیست دوره‌های آموزشی که شما تدریس می‌کنید.</p>
                    </div>
                    <button 
                        className="button button-primary" 
                        onClick={() => setIsModalOpen(true)} 
                    >
                        <FaPlus />
                        ایجاد دوره جدید
                    </button>
                </div>

                <div className="data-table-container">
                    <div className="table-toolbar">
                        <div className="search-box">
                            <FaSearch className="search-icon" />
                            <input
                                type="text"
                                placeholder="جستجو بر اساس عنوان یا پایه..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>عنوان دوره</th>
                                <th>پایه و رشته</th>
                                <th>دانش‌آموزان</th>
                                <th>تکالیف فعال</th>
                                <th>عملیات</th>
                            </tr>
                        </thead>
                        <tbody>
                            {renderTableBody()}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default CourseListPage;